"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RelayEagerLogger;

var _js = require("@adeira/js");

var _logGroup = _interopRequireDefault(require("./logGroup"));

/* eslint-disable no-console */
// See: https://github.com/facebook/relay/commit/da9a57cb0b7ab9bedf82e3d1dddc17a0ad9e4d92
function RelayEagerLogger(logEvent) {
  if (!(process.env.NODE_ENV !== "production") || !(0, _js.isBrowser)()) {
    return;
  }

  var transactionID = logEvent.transactionID != null ? logEvent.transactionID : 99998; // so it clearly results in "-1"

  var groupMessage = "[Relay ".concat(transactionID - 99999, "] ").concat(logEvent.name);

  if (logEvent.name === 'network.start') {
    var _logEvent$params$text, _logEvent$params$text2, _logEvent$params$text3, _logEvent$params$text4;

    (0, _logGroup.default)(groupMessage, function () {
      console.log("Variables: %o", logEvent.variables);
      console.log(logEvent.params.text); // TODO: ID for persistent queries
    }, "".concat(logEvent.params.name, " ").concat(logEvent.params.operationKind === 'mutation' ? "\uD83D\uDCDD (".concat((_logEvent$params$text = (_logEvent$params$text2 = logEvent.params.text) === null || _logEvent$params$text2 === void 0 ? void 0 : _logEvent$params$text2.length) !== null && _logEvent$params$text !== void 0 ? _logEvent$params$text : 0, ")") : "\uD83D\uDD0D (".concat((_logEvent$params$text3 = (_logEvent$params$text4 = logEvent.params.text) === null || _logEvent$params$text4 === void 0 ? void 0 : _logEvent$params$text4.length) !== null && _logEvent$params$text3 !== void 0 ? _logEvent$params$text3 : 0, ")")));
  } else if (logEvent.name === 'network.next') {
    if (Array.isArray(logEvent.response)) {
      // we do not support batch response with @stream yet
      console.warn(logEvent.response);
    } else if (logEvent.response.errors !== undefined) {
      (0, _logGroup.default)(groupMessage, function () {
        console.log("Response: %o", logEvent.response);
      }, 'partial response with errors', 'color:orange');
    } else {
      (0, _logGroup.default)(groupMessage, function () {
        console.log("Response: %o", logEvent.response);
      });
    }
  } else if (logEvent.name === 'network.error') {
    (0, _logGroup.default)(groupMessage, function () {
      console.error(logEvent.error);
    }, undefined, 'color:red');
  } else if (logEvent.name === 'network.complete' || logEvent.name === 'network.unsubscribe') {
    (0, _logGroup.default)(groupMessage);
  } else if (logEvent.name === 'entrypoint.root.consume' || logEvent.name === 'network.info' || logEvent.name === 'queryresource.fetch' || logEvent.name === 'queryresource.retain' || logEvent.name === 'store.gc' || logEvent.name === 'store.notify.complete' || logEvent.name === 'store.notify.start' || logEvent.name === 'store.publish' || logEvent.name === 'store.restore' || logEvent.name === 'store.snapshot') {// explicit noop
  } else {
    checkEmpty(logEvent);
  }
}

function checkEmpty(logEvent) {
  console.error('Relay: cannot decide how to log event: %s', JSON.stringify(logEvent));
}